import { ReactNode } from 'react';

import {
    DefaultTertiaryLayout,
    DefaultTertiaryLayoutProps,
    useNewLayout,
} from '@speeki/client-admin';

import { authService } from '@services/AuthService/AuthService';

export interface PlaceholderLayoutProps extends Partial<DefaultTertiaryLayoutProps> {
    children: ReactNode;
}

export const PlaceholderLayout = ({
    children,
    ...layoutProps
}: PlaceholderLayoutProps) => {
    const props = useNewLayout({
        onLogout: () => authService.logout(),
    });

    return (
        <DefaultTertiaryLayout {...props} {...layoutProps}>
            {children}
        </DefaultTertiaryLayout>
    );
};
